import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {ShopTapBoxV2} from "../common/ShopTapBoxV2";
import {useShopInfo, useShopInfo4} from "../../../static/js/hock/shopHock";
import {formatCost, openPopup} from "../../../static/js/Common2";
import {ShopInfo4PopupV2} from "./ShopInfo4PopupV2";
import {modifyOrderShop} from "../../../static/js/service/shopService";
import $ from "jquery";
import shopModiBtn3 from "../../../static/image/v2/shop/shopModiBtn3.png";
import {dongNameChange} from "../../../static/js/DongVal";
import {subNavEvent} from "../../../static/js/service/commonService";
import {getElementValue, openPopup2, selectBtnEvent2} from "../../../utils/CommonUtils";
import { ORDER_API } from "constants/apiUrls";
import axios from "axios";
import ShopFreeCostPopup from "./ShopFreeCostPopup";
import FreeDeliveryPopup from "./FreeDeliveryPopup";
import WeatherCostPopup from "../../shopInfo4/WeatherCostPopup";
import DefaultDeliveryPopup from "./DefaultDeliveryPopup";

export default function ShopInfo4V22() {
  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState();
  let [tapNumber, setTapNumber] = useState(1);
  let [deliType, setDeliType] = useState(1);
  let [minOrderCost, setMinOrderCost] = useState(0);
  let [packagingCost, setPackagingCost] = useState(0);
  let [dongList, setDongList] = useState([]);
  let [dongExtraList, setDongExtraList] = useState([]);
  let [output, setOutput] = useState([]);
  let [timeExtraList, setTimeExtraList] = useState([]);
  let [approvalTpcd1, setApprovalTpcd1] = useState();
  let [addDistId, setAddDistId] = useState(0);
  let [addDist, setAddDist] = useState(0.1);
  let [addDistCost, setAddDistCost] = useState(0);
  let [freeCostList, setFreeCostList] = useState([]);
  const [weatherCost, setWeatherCost] = useState({cost: 0, enabled: false})
  let [deliverySettingType, setDeliverySettingType] = useState(1);
  let [costList, setCostList] = useState([]);

  useShopInfo4({
    setMinOrderCost, setPackagingCost, setDongList,
    setDongExtraList, setOutput,
    setTimeExtraList, setApprovalTpcd1,
    setAddDistId, setAddDist, setAddDistCost, setFreeCostList, setWeatherCost,
    setDeliverySettingType, setCostList
  }, shopId);
  useShopInfo({setDeliType}, shopId);

  useEffect(() => {
    subNavEvent("shopNav", "shop1");
    document.addEventListener("click", selectBtnEvent2);
  }, []);

  // 행정동별 배달비
  let dongCost = output.map((value, index) => {
    let name = "";
    let cost = formatCost(value[0].extraCost);

    for(let i = 0; value.length > i; i++) {
      name += value[i].admstrDong + ', '
    }
    name = name.slice(0, -2)

    return (
      <p key={index}>
        {name} 배달비 <span className="blue">{cost}원 추가</span>
      </p>
    )
  })

  function minOrderEvent() {
    let minOrder = document.getElementById("minOrder").value;

    modifyOrderShop({
      minOrderCost: Number(minOrder)
    }, shopId)
  }
  function packagingEvent() {
    let packaging = document.getElementById("packagingDiscountCost").value;

    modifyOrderShop({
      packagingDiscountCost: Number(packaging)
    }, shopId)
  }

  // 행정동 초기화
  function selectDong() {
    $('.dongListBox').empty();
    for(var i = 0; dongList.length > i; i++) {
      var result = true

      for(var j = 0; dongExtraList.length > j; j++) {
        if(dongList[i] === dongExtraList[j].admstrName) {
          result = false
        }
      }

      if(result) {
        var label = document.createElement('label')
        label.innerHTML = `${ dongNameChange(dongList[i]) }`
        label.setAttribute('data-idx', `${ dongList[i] }`)

        label.setAttribute('class', 'dongLabel label')
        label.setAttribute('data-type', 0)
        label.setAttribute('data-modi', 0)
        label.setAttribute('data-id', 0)

        $('.dongListBox').append(label)
      }
    }

    $('.dongTextList .selectText').attr('data-id', '0')
    $('.dongTextList .selectText').attr('data-modi', '0')
    $('.dongTextList .selectText').text('신규 추가')
  }

  useEffect(() => {
    document.querySelectorAll(`input[name='deliType'][value='${deliType}']`).forEach(radio => {
      radio.checked = true;
    });
  }, [deliType]);

  const addDistanceEvent = (value) => {
    const distanceSelect = document.getElementById("addDistanceSelect");
    const distanceSelectText = document.getElementById("addDistanceSelectText");

    distanceSelect.classList.remove("active");
    distanceSelectText.innerText = `${value * 1000}m`;
    distanceSelectText.setAttribute("data-id", value);
  }

  // 거리당 추가 배달비 수정
  const addDistanceSetEvent = async (addDistId) => {
    const addDistanceSelectText = document.getElementById("addDistanceSelectText");
    const addDistanceValue = addDistanceSelectText.getAttribute("data-id");
    const addDefaultDistCost = Number(getElementValue("addDistCost"));

    const data = {shopId: shopId}

    if (addDistId === 0) {
      data.addDistanceExtraList = [{
        testDistance: Number(addDistanceValue),
        cost: addDefaultDistCost
      }]
    } else {
      data.setDistanceExtraList = [{
        distanceExtraId: addDistId,
        testDistance: Number(addDistanceValue),
        cost: addDefaultDistCost
      }]
    }

    await axios.post(`${ORDER_API}/cost/extra/distance`, data);
    window.location.reload();
  }

  return (
    <main id="ShopInfo4V2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <ShopInfo4PopupV2
        shopId={shopId} dongList={dongList} timeList={timeExtraList}
        dongCostList={dongExtraList} output1={output}
      />
      <ShopFreeCostPopup shopId={shopId} minOrderCost={minOrderCost} freeCostList={freeCostList} />
      <FreeDeliveryPopup shopId={shopId} minOrderCost={minOrderCost} list={freeCostList} />
      <WeatherCostPopup shopId={shopId} cost={weatherCost.cost} enabled={weatherCost.enabled} />
      <DefaultDeliveryPopup shopId={shopId} listData={costList} />

      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 정보 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 정보 관리" countText="" count="" unit="" />
          </div>
          <div className="topMenu">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/shopInfo4" setShopId={setShopId} setShopList={setShopList} />
              <ShopTapBoxV2 tap="tap4" shopId={shopId} />
            </div>
          </div>
          <div className="shopInfoBox">
            <div className="deliCostTapBox">
              <button
                type="button" className={`deliCostTap bg-transparent ${tapNumber === 1 ? "active" : ""}`}
                onClick={() => setTapNumber(1)}
              >
                배달비
              </button>
              <button
                type="button" className={`deliCostTap bg-transparent ${tapNumber === 2 ? "active" : ""}`}
                onClick={() => setTapNumber(2)}
              >
                포장비
              </button>
            </div>

            {tapNumber === 1 &&
              <table className="shopInfoTable">
                <thead></thead>
                <tbody>
                <tr>
                  <th>최소주문금액</th>
                  <td>
                    <input type="number" id="minOrder" key={minOrderCost} defaultValue={minOrderCost} />원
                    {approvalTpcd1 === 4 &&
                      <button type="button" id="minOrderBtn" onClick={() => minOrderEvent()}>수정</button>
                    }
                  </td>
                </tr>
                <tr>
                  <th>
                    거리별 추가 배달비<br />
                    <span>※거리는 직선거리로 계산됩니다.</span>
                  </th>
                  <td>
                    <div className="costListBox">
                      <div className="d-flex a-center j-left selectBox">
                        <div id="addDistanceSelect" className='addDistanceSelect select width160'>
                          <div id="addDistanceSelectText" className='addDistanceSelectText selectText' data-href="addDistanceSelect" data-id={addDist} >
                            {addDist * 1000}m
                          </div>
                          <ul className='"addDistanceSelectOptionList selectOptionList'>
                            <li className='selectoption' onClick={() => addDistanceEvent(0.1)}>100m</li>
                            <li className='selectoption' onClick={() => addDistanceEvent(0.2)}>200m</li>
                            <li className='selectoption' onClick={() => addDistanceEvent(0.3)}>300m</li>
                            <li className='selectoption' onClick={() => addDistanceEvent(0.4)}>400m</li>
                            <li className='selectoption' onClick={() => addDistanceEvent(0.5)}>500m</li>
                          </ul>
                        </div>
                        <input type="number" id="addDistCost" key={addDistCost} defaultValue={addDistCost} />원
                        <button type="button" id="defaultDistCostBtn" onClick={() => addDistanceSetEvent(addDistId)}>수정</button>
                      </div>
                    </div>
                  </td>
                </tr>
                {deliverySettingType === 1 ?
                  <tr>
                    <th>
                      거리별 무료 배달비<br />
                      <span>※거리별 추가 배달비만 무료로 적용됩니다.</span>
                    </th>
                    <td>
                      <div className="flexTd costListBox">
                        <div className="costList">
                          {freeCostList.map((value, index) => {
                            return (
                              <p key={index}>
                                {value.distance}km 이내 <span className="blue">{value.minOrderCost.toLocaleString()}원 이상</span>
                              </p>
                            )
                          })}
                        </div>
                        {approvalTpcd1 === 4 &&
                          <button type="button" className="ediBtn openBtn" onClick={() => {
                            openPopup2("freeDeliveryPopup");
                          }}>
                            <img src={ shopModiBtn3 } alt="수정" />
                          </button>
                        }
                      </div>
                    </td>
                  </tr>:
                  <tr>
                    <th>
                      금액별 추가 배달비
                    </th>
                    <td>
                      <div className="flexTd costListBox">
                        <div className="costList">
                          {costList.map((value, index) => {
                            return (
                              <p key={index}>
                                {value.testOrderCost.toLocaleString()}원 이상 <span className="blue">{value.deliveryCost.toLocaleString()}원</span>
                              </p>
                            )
                          })}
                        </div>
                        {approvalTpcd1 === 4 &&
                          <button type="button" className="ediBtn openBtn" onClick={() => {
                            openPopup2("defaultDeliveryPopup");
                          }}>
                            <img src={ shopModiBtn3 } alt="수정" />
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
                <tr>
                  <th>
                    지역별 추가 배달비<br />
                    <span>※행정동별로 배달비를 설정할 수 있습니다.</span>
                  </th>
                  <td>
                    <div className="flexTd costListBox">
                      <div className="costList">
                        {dongCost}
                      </div>
                      {approvalTpcd1 === 4 &&
                        <button type="button" className="ediBtn openBtn" onClick={() => {
                          openPopup("dongCostPopup");
                          selectDong()
                        }}>
                          <img src={ shopModiBtn3 } alt="수정" />
                        </button>
                      }
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    시간대별 추가 배달비
                  </th>
                  <td>
                    <div className="flexTd costListBox">
                      <div className="costList">
                        {timeExtraList.map((value, index) => {
                          var day

                          if(value.dowTpcd === 1) {
                            day = '월'
                          } else if(value.dowTpcd === 2) {
                            day = '화'
                          } else if(value.dowTpcd === 3) {
                            day = '수'
                          } else if(value.dowTpcd === 4) {
                            day = '목'
                          } else if(value.dowTpcd === 5) {
                            day = '금'
                          } else if(value.dowTpcd === 6) {
                            day = '토'
                          } else if(value.dowTpcd === 7) {
                            day = '일'
                          }

                          return (
                            <p>{ day }{` (${value.extraStartTm}~${value.extraEndTm})`}<span className='blue'>{` ${formatCost(value.extraCost)}원 추가`}</span></p>
                          )
                        })}
                      </div>
                      {approvalTpcd1 === 4 &&
                        <button type="button" className="ediBtn openBtn" onClick={() => openPopup("timeCostPopup")}>
                          <img src={ shopModiBtn3 } alt="수정" />
                        </button>
                      }
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>기상할증</th>
                  <td>
                    <div className="flexTd costListBox">
                      <div className="costList d-flex a-center j-left">
                        {weatherCost.cost.toLocaleString()}원
                        <span className={`statusBox ta-center d-block fs-14 ml-10 ${weatherCost.enabled ? "" : "redBox"}`}>
                          {weatherCost.enabled ? "사용" : "미사용"}
                        </span>
                      </div>
                      {approvalTpcd1 === 4 &&
                        <button type="button" className="ediBtn openBtn" onClick={() => {openPopup2("weatherCostPopup")}}>
                          <img src={ shopModiBtn3 } alt="수정" />
                        </button>
                      }
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            }
            {tapNumber === 2 &&
              <table className="shopInfoTable">
                <thead></thead>
                <tbody>
                <tr>
                  <th>포장비 할인</th>
                  <td>
                    <input type="number" id="packagingDiscountCost" key={packagingCost} defaultValue={packagingCost} data-modi="0" />원
                    {approvalTpcd1 === 4 &&
                      <button type="button" id="packagingDiscountCostBtn" onClick={() => packagingEvent()}>수정</button>
                    }
                  </td>
                </tr>
                </tbody>
              </table>
            }
          </div>
        </section>
      </div>
    </main>
  )
}